import React from "react";
import {Box, Text} from "@chakra-ui/react";
import {Color} from "util/Color";

interface Props {
    forClient: string;
}

export const Title = React.memo<Props>(({forClient}) => {
    return (
        <Box p={3} backgroundColor="rgb(255 255 255 / 80%)" borderRadius={40} mt={{base: 2, md: 0}} mb={{base: 4, md: 8}}>
            <Box p={4} borderRadius={30} textAlign="center" borderStyle="dashed" borderWidth="1px" borderColor={Color.happyPiglets}>
                <Text fontSize={{base: "18px", md: "22px"}} color={Color.crownOfThorns}>
                    {forClient}
                </Text>
                <Text fontSize={{base: "26px", md: "30px"}} color={Color.crownOfThorns}>
                    網上禮卡製作服務
                </Text>
            </Box>
        </Box>
    );
});
